var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FieldHandler } from "./FieldHandler";
var HandleFieldsList = /** @class */ (function () {
    function HandleFieldsList() {
        var _this = this;
        this.formFields = {};
        this.fieldNames = [];
        this.currentValues = {};
        this.treatUpdateField = function (name, formFields, callback) {
            if (typeof name !== "string") {
                _this.invalidNameError(name);
            }
            else if (formFields[name]) {
                return callback();
            }
            else {
                _this.cantGetField(name);
            }
        };
        this.setNewField = function (name, fieldParams) {
            if (typeof name !== "string") {
                _this.invalidNameError(name);
            }
            else if (!_this.formFields[name]) {
                _this.fieldNames.push(name);
                _this.formFields[name] = new FieldHandler(fieldParams);
                if (_this.currentValues[name]) {
                    _this.setValue(name, _this.currentValues[name]);
                }
            }
            else {
                _this.fieldAlreadyExist(name);
            }
        };
        this.removeField = function (name) {
            _this.treatUpdateField(name, _this.formFields, function () {
                delete _this.formFields[name];
                var nameIndex = _this.fieldNames.indexOf(name);
                _this.fieldNames.splice(nameIndex, 1);
            });
        };
        this.setCurrentValues = function (currentValues) {
            if (currentValues) {
                _this.fieldNames.forEach(function (name) {
                    var _a;
                    if (currentValues[name] !== _this.currentValues[name]) {
                        _this.setValue(name, (_a = currentValues[name]) !== null && _a !== void 0 ? _a : "");
                    }
                });
                _this.currentValues = currentValues;
            }
            else {
                _this.currentValues = {};
            }
        };
        this.setAllDisabled = function (disabled) {
            _this.fieldNames.forEach(function (name) {
                _this.formFields[name].disableHandler(!!disabled);
            });
        };
        this.setFieldRequired = function (name, required) {
            _this.treatUpdateField(name, _this.formFields, function () {
                _this.formFields[name].setRequired(required);
            });
        };
        this.setFieldDefaultValue = function (name, defaultValue) {
            _this.treatUpdateField(name, _this.formFields, function () {
                _this.formFields[name].setDefaultValue(defaultValue);
            });
        };
        this.setFieldLabel = function (name, label) {
            _this.treatUpdateField(name, _this.formFields, function () {
                _this.formFields[name].setLabel(label);
            });
        };
        this.setFieldMask = function (name, mask) {
            _this.treatUpdateField(name, _this.formFields, function () {
                _this.formFields[name].setMask(mask);
            });
        };
        this.setFieldMaskToSubmit = function (name, maskToSubmit) {
            _this.treatUpdateField(name, _this.formFields, function () {
                _this.formFields[name].setMaskToSubmit(maskToSubmit);
            });
        };
        this.setFieldValidation = function (name, validation) {
            _this.treatUpdateField(name, _this.formFields, function () {
                _this.formFields[name].setValidation(validation);
            });
        };
        this.setFieldAsyncValidation = function (name, asyncValidation) {
            _this.treatUpdateField(name, _this.formFields, function () {
                _this.formFields[name].setAsyncValidation(asyncValidation);
            });
        };
        this.getFieldRef = function (name) {
            return _this.treatUpdateField(name, _this.formFields, function () {
                return _this.formFields[name].getRef();
            });
        };
        this.setValue = function (name, value) {
            _this.treatUpdateField(name, _this.formFields, function () {
                _this.formFields[name].handleValue(value);
            });
        };
        this.setFormValue = function (name, value) {
            _this.treatUpdateField(name, _this.formFields, function () {
                _this.formFields[name].setValue(value);
            });
        };
        this._getValueToSubmit = function (name, ffHandler) {
            var value = _this.getValue(name, false, ffHandler);
            if (Boolean(value) || value === 0) {
                return _this.formFields[name].getFormattedValueToSubmit(ffHandler);
            }
        };
        this.clearValue = function (name, setDefault) {
            _this.treatUpdateField(name, _this.formFields, function () {
                _this.formFields[name].clearValue(setDefault);
            });
        };
        this.clearFields = function (setDefault) {
            _this.fieldNames.forEach(function (name) {
                _this.clearValue(name, setDefault);
            });
        };
        this.clearSpecificFields = function (names, setDefault) {
            names.forEach(function (name) {
                _this.clearValue(name, setDefault);
            });
        };
        this._getValue = function (name) {
            return _this.formFields[name].value;
        };
        this._getFinalValue = function (name, ffHandler) {
            var _a = _this.formFields[name], maskToSubmit = _a.maskToSubmit, value = _a.value;
            var selectedValue = value;
            var withMask = selectedValue && maskToSubmit;
            return withMask && maskToSubmit
                ? maskToSubmit(selectedValue, ffHandler)
                : selectedValue;
        };
        this.getValue = function (name, withMaskToSubmit, ffHandler) {
            if (_this.formFields[name]) {
                return withMaskToSubmit
                    ? _this._getFinalValue(name, ffHandler)
                    : _this._getValue(name);
            }
        };
        this.getActualValue = function (name) {
            return _this.currentValues[name];
        };
        this.getValues = function (ffHandler) {
            var data = {};
            _this.fieldNames.forEach(function (name) {
                data[name] = _this._getValueToSubmit(name, ffHandler);
                return null;
            });
            return data;
        };
        this.setFieldFocus = function (name) {
            var ref = _this.getFieldRef(name);
            if (ref) {
                ref.focus();
            }
        };
        this.getValidValues = function (saveToSubmit, ffHandler) {
            var data = {};
            _this.fieldNames.forEach(function (name) {
                var input = _this.formFields[name];
                if (!input.error) {
                    data[name] = saveToSubmit
                        ? _this._getValueToSubmit(name, ffHandler)
                        : input.value;
                }
            });
            return data;
        };
        this._testErrorAndReturnData = function (name, ffHandler, errorCallback) { return __awaiter(_this, void 0, void 0, function () {
            var errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.testFieldError(name, true, ffHandler)];
                    case 1:
                        errorMessage = _a.sent();
                        if (errorMessage) {
                            errorCallback();
                        }
                        return [2 /*return*/, this._getValueToSubmit(name, ffHandler)];
                }
            });
        }); };
        this.testFieldError = function (name, shouldUpdateInput, ffHandler) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.treatUpdateField(name, this.formFields, function () {
                            return _this.formFields[name].validate(shouldUpdateInput, ffHandler);
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.testErrorsAndReturnData = function (ffHandler) { return __awaiter(_this, void 0, void 0, function () {
            var hasError, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hasError = false;
                        data = {};
                        return [4 /*yield*/, Promise.all(this.fieldNames.map(function (name) { return __awaiter(_this, void 0, void 0, function () {
                                var value;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this._testErrorAndReturnData(name, ffHandler, function () {
                                                if (!hasError) {
                                                    _this.setFieldFocus(name);
                                                    hasError = true;
                                                }
                                            })];
                                        case 1:
                                            value = _a.sent();
                                            if (value !== undefined) {
                                                data[name] = value;
                                            }
                                            return [2 /*return*/, null];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, { hasError: hasError, data: data }];
                }
            });
        }); };
    }
    HandleFieldsList.prototype.invalidNameError = function (name) {
        throw new Error("The \"form-full\" field expects to receive the \"name\" property as a string, but it received a \"" + typeof name + "\".");
    };
    HandleFieldsList.prototype.fieldAlreadyExist = function (name) {
        throw new Error("The field \"" + name + "\" has already been created.");
    };
    HandleFieldsList.prototype.cantGetField = function (name) {
        throw new Error("The field \"" + name + "\" doesn't exist and cannot be used/modified.");
    };
    return HandleFieldsList;
}());
export { HandleFieldsList };
